
// import React, { Component, useReducer } from 'react';
import React, { Component, Suspense } from 'react';
//import logo from './logo.svg';
import './App.css';
// import { Route, Switch } from "react-router";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  //Link
} from "react-router-dom";


//import Home from './pages/home/home.js';
//import BookingV2 from './pages/bookingv2/bookingv2.js';
//import Signin from './pages/signin/signin.js';
//import Summary from './pages/summary/summary.js';
//import BookingDetail from './pages/bookingdetail/bookingdetail';
//import BookingApprove from './pages/bookingapprove/bookingapprove';
//import Mybooking from './pages/mybooking/mybooking.js';
//import Signup from './pages/signup/signup.js';
//import ForgotPassword from './pages/forgotpassword/forgotpassword';
//import CreatePassword from './pages/createpassword/createpassword';
//import PrivacyPolicy from './pages/privacypolicy/privacypolicy';
//import Termsandcondition from './pages/termsandcondition/termsandcondition';
//import HowToApplyForCredit from './pages/howtoapplyforcredit/howtoapplyforcredit';
//import Contactus from './pages/contactus/contactus';
import * as utils from './Utils.js';
import * as version from './version.js';


const Home = React.lazy(()=> import('./pages/home/home.js'));
const Signin = React.lazy(()=> import('./pages/signin/signin.js'));
const Summary = React.lazy(()=> import('./pages/summary/summary.js'));
const BookingDetail = React.lazy(()=> import('./pages/bookingdetail/bookingdetail'));
const BookingApprove = React.lazy(()=> import('./pages/bookingapprove/bookingapprove'));
const Mybooking = React.lazy(()=> import('./pages/mybooking/mybooking.js'));

const Signup = React.lazy(()=> import('./pages/signup/signup.js'));
const ForgotPassword = React.lazy(()=> import('./pages/forgotpassword/forgotpassword'));
const CreatePassword = React.lazy(()=> import('./pages/createpassword/createpassword'));

const PrivacyPolicy = React.lazy(()=> import('./pages/privacypolicy/privacypolicy'));
const Termsandcondition = React.lazy(()=> import('./pages/termsandcondition/termsandcondition'));

const HowToApplyForCredit = React.lazy(()=> import('./pages/howtoapplyforcredit/howtoapplyforcredit'));
const Contactus = React.lazy(()=> import('./pages/contactus/contactus'));
const BookingV2 = React.lazy(()=> import('./pages/bookingv2/bookingv2.js'));






class App extends Component {

  constructor(props) {
    console.log(version.version());
    super(props);
    this.state = {
      languageCode: "TH_TH",
      redirectUrl: "",
      //displayName: "John Snow",
      //email: "johnsnow@mail.com",
      //isLogin: true,
      userObject: null,
      dic: null,
      changeLanguage: this.changeLanguage,
      logout: this.logout,
      checkUser: this.checkUser,
      storeUserObject: this.storeUserObject
    };
    this.setPageTitle(this.state.languageCode);
    //this.checkuser();



  }

  // componentDidMount() {
  //   this.checkuser();
  // }
  componentDidMount() {

  
    //console.log("debug userObject");
    //console.log(this.state.userObject);
    this.loadDic(this.state.languageCode, null);
  }


  storeUserObject = () => {
    let userObject = { ...this.state.userObject }
    window.localStorage.setItem("userObject1", JSON.stringify(userObject));
    // this.setState({
    //   //languageCode: languageCode
    //   //userObject: userObject,
    //   //languageCode: languageCode
    // });
  }



  changeLanguage = () => {

    if (this.state.userObject === null) {
      let languageCode = this.state.languageCode;
      if (languageCode === "EN_US") {
        languageCode = "TH_TH";
        this.setPageTitle(languageCode);
      }
      else {
        languageCode = "EN_US";
        this.setPageTitle(languageCode);
      }
      this.setState({
        //languageCode: languageCode
        //userObject: userObject,
        languageCode: languageCode
      });
      this.loadDic(languageCode, null);


    }
    else {
      let userObject = { ...this.state.userObject }
      let languageCode = userObject.languageCode;
      if (languageCode === "EN_US") {
        languageCode = "TH_TH";
        this.setPageTitle(languageCode);
      }
      else {
        languageCode = "EN_US";
        this.setPageTitle(languageCode);
      }
      userObject.languageCode = languageCode;
      window.localStorage.setItem("userObject1", JSON.stringify(userObject));
      this.setState({
        //languageCode: languageCode
        userObject: userObject,
        languageCode: languageCode
      });


      //console.log(userObject);

      this.loadDic(languageCode, userObject.userId);
    }



  }



  checkUser = (appState) => {


    //var urlSearchParams = new URLSearchParams(window.location.search);
    //var params = Object.fromEntries(urlSearchParams.entries());
    //var request_url = params.request_url;


    var url = "/signin?request_url=" + window.location;
    // if(request_url != undefined && request_url != ""){
    //     url = "/signin?request_url="+window.location;
    // }

    // alert(url);
    

    let userObject = appState.userObject;


    //console.log(userObject);
    //alert("checkuser");



    if (userObject === null) {


      if (window.localStorage.getItem("userObject1") === null) {
        console.log("userObject1 is null");
        console.log("redirect to signin");
        window.location.replace(url);
      }
      else {
        
        let userObject = JSON.parse(localStorage.getItem("userObject1"));

        if (userObject.selectcompanyId === undefined) {
          console.log("select companyid is undefined");
          window.localStorage.removeItem("userObject1");
          window.location.reload();
        }
        if (userObject.selectcompanyId === null) {
          console.log("select companyid is null");
          window.localStorage.removeItem("userObject1");
          window.location.reload();
        }
        if (userObject.selectcompanyId === "") {
          console.log("select companyid is empty string");
          window.localStorage.removeItem("userObject1");
          window.location.reload();
        }

        appState.userObject = userObject;

        //console.log("debug userObject");
        //console.log(userObject);

        appState.languageCode = userObject.languageCode;
        //alert("checkuser");

        if (appState.userObject.UserType !== 1) {
          console.log("user is not end user");
          window.location.replace(url);
        }


        this.setState({
          // userObject:userObject
        })
        this.loadDic(userObject.languageCode, null);
      }
    }





    //console.log(this.state.userObject);


    //var urlSearchParams = new URLSearchParams(window.location.search);
    //var params = Object.fromEntries(urlSearchParams.entries());
    //var request_url = params.request_url;






    //alert(request_url);
    //alert(window.location);

    //  var url = "/";
    // if(request_url!== undefined){
    //   url = "/signin?request_url="+window.location;
    // }

    // //var location = window.location;

    // //alert(location);


    // //var url = "/signin?request_url="+window.location;

    // //alert(url);



    // let userObject = appState.userObject;

    // console.log("check user");
    // console.log(userObject);

    // alert("xx");
    // if (userObject === null) {
    //   if (window.localStorage.getItem('userObject') === null) {
    //     alert("xx1");
    //     window.location.replace(url);
    //   }
    //   else {
    //     alert("xx2");
    //     let userObject = JSON.parse(localStorage.getItem("userObject1"));
    //     appState.userObject = userObject;

    //     //console.log("debug userObject");
    //     //console.log(userObject);

    //     appState.languageCode = userObject.languageCode;


    //     if(appState.userObject.UserType !== 1){
    //       window.location.replace(url);
    //     }


    //     this.setState({
    //       // userObject:userObject
    //     })
    //     this.loadDic(userObject.languageCode);
    //   }
    // }
  }

  logout = () => {
    if (this.state.userObject != null) {
      let userObject = this.state.userObject;

      let data = {};
      let token = userObject.Token;

      data.Id = userObject.userId;
      data.Token = userObject.Token;
      let url = process.env.REACT_APP_API_END_POINT + "/api/Corp/Logout";
      utils.callPost(url, token, data, this.logoutCallBack);
    }
    else {
      window.localStorage.removeItem("userObject1");
      window.location.reload();
    }
  }
  logoutCallBack = () => {
    window.localStorage.removeItem("userObject1");
    //window.location.reload();
    var url = "/signin";
    window.location.replace(url);
  }





  setPageTitle = (languageCode) => {
    if (languageCode == "TH_TH") {
      document.title = "ระบบการจองห้องพักโรงแรมฮ็อป อินน์ สำหรับลูกค้าบริษัท";
    }
    else {
      document.title = "HOP INN hotel reservation system for business customers";
    }
  }



  loadDic = (languageCode, userid) => {
    let token = null;
    let url = process.env.REACT_APP_API_END_POINT + "/api/corp/getdic";
    let data = {};
    data.languageCode = languageCode;
    if (userid != undefined && userid != null) {
      data.userId = userid;
    }
    utils.callPost(url, token, data, this.loadDicCallBack);
  }
  loadDicCallBack = (res) => {
    this.setState({
      dic: res.Data
    });
  }
  render() {



    //console.log(this.state);


    // if (this.state.redirectUrl !== "") {
    //   alert("redirect");
    //   let redirectUrl = this.state.redirectUrl;
    //   this.state.redirectUrl = "";
    //   return (
    //     <Router>
    //       <Redirect from="*" to={redirectUrl} />
    //     </Router>
    //   )
    // }

    if (this.state.dic !== null) {
      return (
        <Router>
          <Switch>
            <Route exact path="/" children={<Suspense fallback={<div>Loading...</div>}><Home appState={this.state} /></Suspense>} />
            <Route exact path="/signin" children={<Suspense fallback={<div>Loading...</div>}><Signin appState={this.state} /></Suspense>} />
            <Route exact path="/signup" render={(props) => ( <Suspense fallback={<div>Loading...</div>}><Signup appState={this.state} /></Suspense>)} />
            <Route exact path="/forgotpassword" render={(props) => ( <Suspense fallback={<div>Loading...</div>}><ForgotPassword appState={this.state} /></Suspense>)} />
            <Route exact path="/booking" render={(props) => (<Suspense fallback={<div>Loading...</div>}><BookingV2 appState={this.state} /></Suspense>)} />
            <Route exact path="/mybooking" render={(props) => (<Suspense fallback={<div>Loading...</div>}><Mybooking appState={this.state} /></Suspense>)} />
            <Route exact path="/summary/:id/" render={(props) => (<Suspense fallback={<div>Loading...</div>}><Summary appState={this.state} id={props.match.params.id} /></Suspense> )} />
            <Route exact path="/bookingdetail/:id" render={(props) => (<Suspense fallback={<div>Loading...</div>}><BookingDetail appState={this.state} id={props.match.params.id} /></Suspense>)} />
            <Route exact path="/BookingApprove/:id" render={(props) => (<Suspense fallback={<div>Loading...</div>}><BookingApprove appState={this.state} id={props.match.params.id} /></Suspense>)} />
            <Route exact path="/privacypolicy" render={(props) => (<Suspense fallback={<div>Loading...</div>}><PrivacyPolicy appState={this.state} /></Suspense>)} />
            <Route exact path="/termsandcondition" render={(props) => (<Suspense fallback={<div>Loading...</div>}><Termsandcondition appState={this.state} /></Suspense>)} />
            <Route exact path="/howtoapplyforcredit" render={(props) => ( <Suspense fallback={<div>Loading...</div>}><HowToApplyForCredit appState={this.state} /></Suspense>)} />
            <Route exact path="/contactus" render={(props) => (<Suspense fallback={<div>Loading...</div>}><Contactus appState={this.state} /></Suspense>)} />
            <Route exact path="/createpassword/:id" render={(props) => (<Suspense fallback={<div>Loading...</div>}><CreatePassword appState={this.state} id={props.match.params.id} /></Suspense>)} />
          </Switch>
        </Router>

      );
    }
    else {
      return (<>&nbsp;</>);
    }









    // if (this.state.userObject === null) {
    //   alert("Signin");
    //   return (
    //     <Router>
    //       <Switch>
    //         <Route exact path="/signin" children={<Signin appState={this.state} />} />
    //       </Switch>
    //     </Router>
    //   );
    // }
    // else {
    //   return (
    //     <Router>
    //       <Switch>
    //         <Route exact path="/" children={<Home appState={this.state} />} />
    //         <Route exact path="/signin" children={<Signin appState={this.state} />} />
    //       </Switch>
    //     </Router>
    //   );
    // }
  }
}
export default App;
